<script lang="ts">
    import SegmentedControls from '@amp/web-app-components/src/components/SegmentedControls/SegmentedControls.svelte';
    import ClickAction from '~/components/jet/action/ClickAction.svelte';
    import { getJet } from '~/jet';

    export let tabs;

    const jet = getJet();

    $: items = makeTabItems(tabs);
    $: selectedItem = items.find((item) => item.focused);
    $: selectedId = selectedItem?.id;

    function makeTabItems(tabs) {
        return tabs.map((tab) => {
            const id = tab.title.toLowerCase();
            return {
                id,
                ariaLabel: tab.title,
                label: tab.title,
                action: tab.action,
                focused: tab.focused,
            };
        });
    }

    function updateSelected(e: CustomEvent): void {
        const newSelectedId = e.detail;
        const newlySelectedItem = items.find(
            (item) => item.id === newSelectedId,
        );
        jet.perform(newlySelectedItem.action);
    }
</script>

<SegmentedControls
    {items}
    {selectedId}
    on:toggleSelected={updateSelected}
    centerControls={true}
    clickComponent={ClickAction}
    useSmallControls={false}
/>

<style lang="scss">
    // Set number of segment controls
    // TODO: rdar://135436713 (Web Classical Music: ScopeBarPills: Configure Mobile Animation to support more than 3 segments)
    :global(.search-scope-bar__pill-container::before) {
        --numControls: 3;
        --controlOffset: 1.25px;
    }
</style>
